module.exports = __webpack_public_path__ + "static/media/sprite_exp_card_t1.d45b07bb.png";